import { FC, ReactNode, useEffect, useState } from "react";
import { ReactComponent as SpinnerIcon } from "./assets/spinner.svg";
import { ReactComponent as DoneIcon } from "./assets/done.svg";
import { ReactComponent as ErrorIcon } from "./assets/error.svg";
import styles from "./icon-button.module.scss";
import classNames from "classnames";

type Props = {
  children: ReactNode;
  onClick: () => void;
  isProcessing?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  isDisabled?: boolean;
};

export const IconButton: FC<Props> = ({
  children,
  onClick,
  isProcessing = false,
  isSuccess = false,
  isError = false,
  isDisabled = false,
}) => {
  const [isStateShown, setIsStateShown] = useState(false);

  const clickHandler = () => {
    if (isDisabled) return;
    onClick();
  };

  useEffect(() => {
    if (isSuccess || isError) {
      setIsStateShown(true);
      setTimeout(() => {
        setIsStateShown(false);
      }, 1500);
    }
  }, [isSuccess, isError]);

  return (
    <div
      className={classNames(styles.icon_button, {
        [styles.disabled]: isDisabled,
      })}
      onClick={clickHandler}
      role="button"
    >
      <div
        className={classNames(styles.children, {
          [styles.processing]: isProcessing,
        })}
      >
        {children}
      </div>
      <div className={styles.state}>
        {isProcessing && <SpinnerIcon />}
        {isSuccess && isStateShown && <DoneIcon />}
        {isError && isStateShown && <ErrorIcon />}
      </div>
    </div>
  );
};
